import { XMarkIcon } from '@heroicons/react/24/outline'
import { Flex, Text, Title } from '@tremor/react'
import { useEffect } from 'react'

export default function BillingCancelPage() {
    useEffect(() => {
        window.localStorage.removeItem('checkout_session_id')
    }, [])

    return (
        <Flex
            className="p-4 bg-gray-50 w-auto min-w-[1000px] max-w-fit mt-4 rounded-md"
            flexDirection="col"
            justifyContent="start"
            alignItems="start"
        >
            <Flex
                flexDirection="col"
                alignItems="center"
                justifyContent="center"
            >
                <XMarkIcon className="bg-red-600 text-white rounded-full w-20 h-20 p-3 my-6" />
                <Title className="w-fit text-teal-600 mb-2">
                    Payment failed
                </Title>
            </Flex>
        </Flex>
    )
}
